var _style, _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDontknow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 425.2 425.2",
    style: {
      enableBackground: "new 0 0 425.2 425.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n\t.st1{fill:#6BB033;}\n\t.st2{fill:#D0DFE6;}\n\t.st3{fill:none;stroke:#000000;stroke-linecap:round;stroke-linejoin:round;}\n\t.st4{fill:#FFFFFF;stroke:#000000;stroke-linecap:round;stroke-linejoin:round;}\n\t.st5{fill:none;stroke:#1D1D1B;stroke-linecap:round;stroke-linejoin:round;}\n\t.st6{fill:none;stroke:#1D1D1B;stroke-width:1;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:4.0001;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "fond_blanc"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M96.5,375.6c79.1,50.5,163.9,25,249-58.2c38-37.1,67.6-102.8,51.9-152.6C381.5,115,282.9,8.9,177,50.7 s-59.8,66.9-89.4,97.7c-23,23.9-31.9,18.1-54.4,63.2S53.2,348,96.5,375.6L96.5,375.6z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Calque_3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M264.9,217.7c0.1,0.3,0.3,0.6,0.4,0.9c-2.4,0.3-4.7,0.6-7.1,0.9c-1.5,0.2-3.1,0.4-4.6,0.6 c-1.4,0.2-2.7,0.4-4.1,0.6c-11.2,1.6-22.4,3.6-33.6,5.6c-6.1,1.1-12.2,2.2-18.3,3.2c0.1-5.8,0-11.6-0.5-17.4 c-0.1-0.7-0.1-1.4-0.2-2.1c-0.1-1-0.2-1.9-0.3-2.9c-0.4-4.1-1.1-8.1-1.9-12.1c-0.7-3.4-3.1-9.9-3.4-9.9c-0.6,0-1.2-0.1-1.8-0.2 c-0.9-0.2-1.8-0.6-2.7-1l0,0c-0.2-0.1-0.4-0.2-0.6-0.3c-0.1,0-0.1-0.1-0.1-0.1c-0.4-0.2-0.8-0.4-1.1-0.6c-0.2-0.1-0.4-0.2-0.6-0.3 c0.8,4.1,1.4,8.2,2.2,12.3c0.8,4.4,1.4,8.9,1.9,13.1c0,0.3,0.1,0.5,0.1,0.8c0.3,3.1,0.6,6.2,0.7,9.3c0.2,3.9,0.2,7.9,0.1,11.8 l-6.2,30.6l-43.4-26.1c0.5-4.8,2.2-34.5,10.3-43.4c5.8-6.4,13.4-10.9,19.9-11.6s11.4,1.6,11.4,1.6l17.1,4.3c0,0,3.7,14.5,17.9,20.1 c16.6,6.5,24.9-4.9,26.8-7.9c0.3-0.4,3.5-10.2,3.5-10.2c0.4,0.6,0.5,1.2,0.8,1.6c1.3,2.1,2.8,3.9,3.9,5.5c0.6,0.9,1.2,1.8,1.8,2.6 c1.9,2.9,3.8,5.8,5.5,8.8C260.9,209.6,263,213.6,264.9,217.7L264.9,217.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M254,182.4c-0.2-0.1,21.7-14.1,37.7,12.6c4.7,7.9,10.1,47.2,10.1,47.2l-20.6,4.1 C277,217.7,262.6,192.5,254,182.4L254,182.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.8,106.9l-3-0.1l0.8-13.9l-3.4,14.7l-3.9,0.4l2.1-13.5l-5.7,13.2l-10.7,0.4l1.6-9.2c-0.6,1.2-0.6,4-3,5.2 c-16.3,8.3-23.5,20.8-23.5,20.8s0.9,19-4.1,20.6c-2,0.6-8-15.1-8-15.1s-6.3-3.7-11.1,5.2s3.5,19.7,7.3,21.7 c3.5,1.9,14.9,4.1,14.9,4.1l7.5,7.9c0.1-0.3-1.9,5.1-3.8,10.4c-3.8,11.1-20.2,4.7-25.8,1.7s-13.7-1.8-13.7-1.8s2.1-63.2,12.8-79.6 c8.5-13,22.5-21.7,22.5-21.7s12-5.2,26.8-5.2c8.1,0,13.9,4.1,17.5,7.8c-0.6,0.8-1,1.3-1,1.5c0,0.1,0,0.1,0,0.1 c0.1,0.5,0.7,1.8,2.5,2.6c0.4,0.2,0.9,0.2,1.3,0.1h0.1c0.2-0.1,0.3-0.1,0.5-0.2c0.4,0.6,0.7,1.1,0.9,1.4 C255.5,91.4,253.8,106.9,253.8,106.9L253.8,106.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.4,80.5L260.4,80.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.6,76.9l4.6,13.8l14.4,18.5l-0.1,30.4c0,0-1.7,17.8-5.3,24.8s-17.7,9.8-17.7,9.8s-3.5,11,7.3,12.4 c9.5,1.2,11.7-8.7,19.2-7.6c9.4,1.4,14.5,4.2,15.7,4.3c0.5,1.1-12.6-73.5-17.1-84.2C264.5,99.2,254.3,76.5,243.6,76.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M239.3,174.7c0,0-1,5,0.5,7.7c-13.4,0.6-28.4-11.2-28.4-11.7c-0.3-0.7,1-1.8,0.7-2.5 C212.2,168.3,216.8,176.6,239.3,174.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M203.8,159.4c0.1,0.1,0.1,0.3,0.2,0.4c6.1,12.4,23.8,16.9,37.7,14.1c1.8-0.4,3.5-0.9,5.2-1.5 c8.9-3.3,13.2-11.2,15.4-19.8c0.2-0.7,0.3-1.4,0.5-2.1c0.8-3.7,1.2-7.4,1.6-10.9c0.1-0.7,0.1-1.3,0.2-2c0.1-0.9-1.3-19.6-1.9-28.4 c-0.2-2.9-1.1-5.8-2.7-8.2l-5.4-8.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M221.2,143.2c-0.5,2.6-4,4-7.8,3.2s-6.4-3.6-5.9-6.1c0.5-2.6,4-4,7.8-3.2S221.7,140.6,221.2,143.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M204,159.8c-0.1,0-0.1,0.1-0.2,0.1c-6.4,2.4-15.4-2.1-19.3-6.8c-3.7-4.5-5-10.4-3.3-15.6 c1.1-3.6,5.8-7.6,9.9-8"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M251.5,84.8c0.4,0.4,0.7,0.9,1,1.3c1.8,2.8,2.1,6.3,2.3,9.5c0.1,2.4,0.1,9.2-0.9,11.2c-0.1,0-0.1,0-0.1,0 c-1.4,0.2-2.9,0.3-4.3,0.4c0.2-0.2,0.4-0.4,0.6-0.6c1.7-1.8,1.7-8.5,1.6-10.9c-0.1-1.6-0.4-3.2-0.9-4.7c0.1,2-0.1,4-0.5,5.9 c-0.4,2.2-0.9,8.6-1.9,10.5c-0.9,0.1-1.8,0.2-2.7,0.3c-0.4,0-0.8,0.1-1.2,0.1c0.3-0.6,1.2-5.6,1.4-6.2c0.7-1.8,0.4-3.7,0.6-5.6 c0.1-0.6,0.1-1.1,0.1-1.7c-1.1,3.2-2.7,6.2-4.6,8.7c-0.2,0.3-0.8,4.2-1.1,4.5c-1.3,0.1-2.5,0.2-3.8,0.3c-1.4,0.1-2.7,0.2-4.1,0.4 c-0.9,0.1-2,0.1-2.9,0.3c0-0.2,0.1-0.3,0.1-0.5c0.3-1,0.9-5.6,1.1-6.6c0.5-1.9,0.9-3.9,1.1-6c0-0.1,0-0.2,0-0.3 c-0.1,0.6-0.3,1.2-0.5,1.8c-2.4,7.4-9.3,9.7-14.6,14.6c-1.4,1.3-3.7,3.5-5.2,4.7c-1.4,1.2-4.1,4.6-5.6,6.6 c-1.3,1.7-1.4,3.4-1.4,4.1c-0.1,3.8-0.1,7.5-0.4,11.3c-0.1,1.5-0.3,3-0.8,4.4c-0.5,1.3-1.4,3-2.8,2.8c-1.4-0.3-1.8-2.3-2.2-3.6 c-0.6-1.7-1.1-3.3-1.8-4.9c-1.2-2.8-3-5.7-5.5-7c-0.2-0.1-0.3-0.3-0.4-0.5c-0.3-0.1-0.5-0.4-0.6-0.8c-0.8-6.8,0.6-13.4,3-19.6 c1.1-2.8,2.5-5.3,4.3-7.5c1.9-2.2,3.9-4.2,5.9-6.2c2.1-2.1,4.2-4.2,6.3-6.3c2-2,4-4,6.2-5.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M247.8,78.4c-3.4-2.2-6.1-2.7-10.7-4c-13.9-3.9-29.6-0.1-41.6,9.2c-5.6,4.3-10.4,9.7-14.1,16.2 c-4,7-6.2,15.1-7.2,23.4c-0.6,4.8-0.9,9.6-1.2,14.4c-0.4,5-0.7,10-1,15c-0.6,10-1.2,15.1-1.3,25.1"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M180.1,258.5c-2.2,16.5-4.6,32.6-7.9,46.7c0,0.1,0,0.1-0.1,0.2c-1.5,6.6-3.8,12.4-7.1,16.2 c-4.4,5.2-10.7,6.6-19.5,1.1c-2.7-1.7-4.9-4.2-6.5-7.1c0,0,0-0.1-0.1-0.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M189.4,229.4c0.1-3.9,0.1-7.9-0.1-11.8c-0.1-3.1-0.4-6.2-0.7-9.3c0-0.2-0.1-0.5-0.1-0.8 c-0.4-4.2-1.1-8.7-1.9-13.1c-0.7-4.1-1.4-8.2-2.2-12.3c0.2,0.1,0.4,0.2,0.6,0.3c0.4,0.2,0.8,0.4,1.1,0.6c0.1,0,0.1,0.1,0.1,0.1 c0.2,0.1,0.4,0.2,0.6,0.3l0,0c0.9,0.4,1.8,0.8,2.7,1.1c0.6,0.1,1.2,0.2,1.8,0.2c0.3,0,2.7,6.6,3.4,9.9c0.8,4,1.4,8.1,1.9,12.1 c0.1,1,0.2,1.9,0.3,2.9c0.1,0.7,0.1,1.4,0.2,2.1c0.5,5.8,0.6,11.6,0.5,17.4c6.1-0.9,12.2-2.1,18.3-3.2c11.2-2.1,22.4-4,33.6-5.6 c1.4-0.2,2.7-0.4,4.1-0.6c1.5-0.2,3.1-0.4,4.6-0.6c2.3-0.3,4.7-0.6,7.1-0.9c-0.1-0.3-0.3-0.6-0.4-0.9c-1.9-4.1-4-8.1-6.3-12 c-1.7-3-3.6-5.9-5.5-8.8c-0.6-0.9-1.2-1.8-1.8-2.6c-1.1-1.6-2.6-3.4-3.9-5.5c-0.3-0.4-0.4-1-0.8-1.6c-0.4-0.7-1.1-1.4-2.6-2 c0.4,0,2.7,0.6,3.1,0.5c0.3,0,0.7-0.1,1-0.2c0.2-0.1,0.4-0.1,0.5-0.1c0.2-0.1,0.4-0.1,0.6-0.2c0.7-0.2,1.4-0.5,2-0.8 c0.4-0.2,0.4-0.2,0,0c0.9-0.4,1.8-0.9,2.6-1.4c0.6-0.3,0.6-0.3,0,0c0.4,0.8,0.9,1.7,1.4,2.5c0.1,0.1,0.6,0.8,0.7,1c0,0,0,0,0,0.1 c0.2,0.3,0.5,0.7,0.7,1c0.8,1.1,1.6,2.2,2.4,3.3c2.6,3.7,5,7.6,7.1,11.5c2.2,4,4.1,8.1,5.8,12.3c0.4,1,0.8,2.1,1.1,3.1l0,0 c1.8,6.3,4.1,12.6,5.9,19.1c1.8,6.3,3.2,12.7,3.4,19.1c0.6,18.3-7.7,59.6-6.2,67.1c2.6,12.9,4.1,25.9,5,39"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M157.7,361.5v-0.1c4.2-11.9,9.8-23.2,15.1-34.6c2.3-4.8,4.6-9.6,7-14.5c-0.1-0.8-0.3-1.6-0.4-2.4 c0-0.2-0.1-0.4-0.1-0.6c-0.4-2.6-0.8-5.1-1.2-7.7c-0.1-0.9-0.2-1.7-0.4-2.6c-0.2-1.3-0.4-2.6-0.6-3.9c-0.1-0.7-2.2-3.7-2-4.4 c3.1-8.9,3-23.1,4.9-32.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M204.4,158.6C204.4,158.6,204.4,158.5,204.4,158.6C204.4,158.5,204.4,158.5,204.4,158.6 c-0.1-0.4-0.2-0.7-0.4-1l-0.3-0.4c-0.2-0.3-0.4-0.6-0.7-0.8c-0.2-0.1-0.3-0.3-0.4-0.4c0,0-0.1,0-0.1-0.1c-0.3-0.1-0.7-0.3-1-0.4 c-0.1,0-0.1,0-0.1,0h-0.1c-0.4-0.1-0.7-0.1-1.1-0.1c0,0,0,0-0.1,0c-0.3,0-0.6,0.1-1,0.1l0,0c-0.1,0-0.9,0.4-0.9,0.4h-0.1l0,0 c-0.1,0.1-0.3,0.2-0.4,0.3c-0.3,0.2-0.5,0.4-0.7,0.8c-0.1,0.1-0.2,0.3-0.3,0.4c0,0.1-0.1,0.2-0.1,0.3l0,0c0,0.1-0.1,0.1-0.1,0.2 c-0.1,0.3-0.2,0.6-0.3,0.9v0.1c-0.1,0.2-0.1,0.4-0.1,0.6c0,0.2-0.1,0.4-0.1,0.6v0.1c0,0.3,0.1,0.6,0.1,0.9c0,0.1,0,0.1,0,0.2 c0.1,0.2,0.1,0.3,0.2,0.5c0.1,0.1,0.1,0.3,0.2,0.5c0,0.1,0.1,0.1,0.1,0.2c0.1,0.1,0.2,0.3,0.3,0.4c0.1,0.1,0.2,0.3,0.3,0.4 c0,0.1,0.1,0.1,0.1,0.1c0.3,0.2,0.6,0.5,0.8,0.7c0.1,0,0.1,0.1,0.2,0.1c0.1,0.1,0.4,0.1,0.4,0.2c0.1,0,0.3,0.1,0.4,0.2h0.1 c0,0,0,0,0.1,0c0.2,0,0.7,0.1,0.9,0.1h0.1c0.1,0,0.4-0.1,0.5-0.1c0,0,0.3,0,0.5-0.1h0.1c0.1-0.1,0.4-0.2,0.4-0.2 c0.1-0.1,0.3-0.1,0.5-0.2c0,0,0.1,0,0.1-0.1l0,0c0.2-0.1,0.6-0.5,0.8-0.6c0,0,0.1,0,0.1-0.1s0,0,0.1-0.1c0,0,0,0,0-0.1 c0.2-0.3,0.4-0.6,0.6-0.8c0-0.1,0.1-0.1,0.1-0.2c0.1-0.2,0.1-0.4,0.2-0.5c0-0.1,0.1-0.3,0.2-0.5V161c0.1-0.5,0.2-1,0.1-1.5 C204.5,159.3,204.4,158.9,204.4,158.6L204.4,158.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M213.5,256.7c1.6,12,2.7,18.8,4.5,30.8c0.2,1.4,0.3,2.8,1.2,3.8c0.8,0.9,2,1.4,3.1,1.9c2.6,1.3,5.2,2.6,7.8,4 c2.6,1.3,5.3,2.7,7.9,4c1.2,0.6,2.4,1.4,3.7,1.7c1.2,0.3,2.3,0,3.3-0.7s1.9-1.7,2.8-2.6c1-1,2-2,2.9-3c1.9-2,3.8-4,5.6-6.1 c0.9-1,1.8-2.1,2.7-3.2c0.8-1,1.7-2,2.1-3.3s0.4-2.8,0.4-4.1c0.1-1.5,0.1-3,0.1-4.5c0.1-6-2.5-19-3-24.9 M258.7,250.6 c-11.4,2-22.9,3.5-34.4,4.9c-3,0.4-7.7,0.6-10.7,1.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M51.8,225.6c-0.3-0.3-5.3-4.7-5.3-4.7l-1-3c0,0,0.2,0,0.4,0c0.8,0,3.8-0.1,4.7,0 C50.9,217.9,52,225.9,51.8,225.6L51.8,225.6z M139.1,315.6c0,0,0-0.1-0.1-0.1c-1.2-1.8-2.2-3.8-3.3-5.6c-2.2-3.7-4.4-7.4-6.7-11.1 c-4.5-7.6-9.1-15.1-13.6-22.7c-8.2-13.8-16.3-27.7-24.1-41.8l0,0c-3.6,0.1-7.2,0.3-10.9,0.5c-8.7,0.5-17.3,1.2-26,1.8 c-4.4,0.3-8.8,0.6-13.2,0.8c-2.1,0.1-4.3,0.3-6.4,0c-2-0.3-3.3-1.8-4.8-3.1c-3.3-2.9-6.6-5.8-9.9-8.6c-0.9-0.8-1.8-1.6-2.7-2.3 c-0.7-0.6-1.6-1.2-2.2-1.9c-1.5-1.6,0.1-3.1,1.4-4c0.5-0.3,1.1-0.6,1.7-0.9c-0.2-0.4-0.5-0.8-0.7-1.2c-0.3-0.5-0.1-1.5,0.5-1.8 c1.3-0.6,2.6-1.1,3.9-1.3l0,0c1-0.1,2.1,0,3.1,0.5c2,0.9,3.2,2.9,4.4,4.7c1.5,2.1,3,4.2,4.5,6.3c0.2,0,0.4,0,0.6,0l0,0 c0.7,0,1.3,0,2,0c0.5,0,0.5,0,0,0c0.2,0,0.4,0,0.6,0c-0.2-0.2-0.3-0.4-0.5-0.6c-0.8-1.2-0.9-2.4-0.9-3.8c0-0.7,0-1.4,0-2.1l0,0 c-1-0.6-2-1.5-1.7-2.8c0.2-0.9,0.9-1.8,1.6-2.5c0-0.8,0-1.6,0-2.4v-1.4c0-1.5,0-3.1,0-4.4c0-0.9,0-0.9,0,0c0,1.3,0,0,0-0.1 c0-2.1,0.2-3.7,0.5-4l0.1-0.1c0.6-0.4,2.2-0.9,4.5,0.1c0.6,0.2,1,0.7,1.2,1.2l0,0l0,0c0.4,0.7,0.6,1.6,0.7,2.4 c0.3,1.8,0.7,3.5,1,5.3c0.2,0,0.4,0,0.5-0.1l0,0c0.5-0.1,0.9-0.1,1.4-0.1c0.9-0.1,1.8-0.1,2.7-0.1c0.1,0,0.2,0,0.2,0l0,0 c0.2,0,0.4,0,0.6,0c-0.2-2.1-0.3-4.2-0.7-6.2c-0.2-0.7,0.3-1.4,1-1.4c0.3,0,0.6,0,0.9,0.1l0,0c3.7,0.6,5.7,4.4,6.6,8.1 c0.1,0,0.2,0,0.2,0c0.1,0,0.3,0,0.4,0.1c1.9,0.2,3.6,0.3,5.4-0.3c1.8-0.7,3.7-1.4,5.5-2.2c1.8-0.7,3.7-1.4,5.5-2.1 c1.7-0.6,3.1-1.2,4.9-0.4c3.2,1.4,6.3,3.2,9.3,5.1c5.4,3.4,10.7,7.4,15.1,12.1c5.4,4.1,29.2,26.4,33.9,30.8 c0.5,0.5,0.9,0.9,1.4,1.5c3.7,4.7,22.7,29,23.1,34.8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.1,116.5l5.7,1.9c0.6,0.2,1.3-0.2,1.5-0.8l0,0c0.2-0.7-0.2-1.4-0.8-1.6l-5.7-1.9c-0.6-0.2-1.3,0.2-1.5,0.8l0,0 C247.1,115.6,247.5,116.3,248.1,116.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.6,123.6l4.4-2c0.6-0.2,0.9-1,0.6-1.6l-0.1-0.2c-0.2-0.6-0.9-0.9-1.5-0.7l-4.4,2c-0.6,0.2-0.9,1-0.6,1.6l0.1,0.2 C224.4,123.6,225,123.9,225.6,123.6z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 17.9,
    y1: 215.5,
    x2: 33.3,
    y2: 231.8
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M56.4,207.2l3.9,12.7c0,0,2.7-2.2,9.5-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.7,125.8h0.1c1.1,0,2,0.9,2,2v3.2c0,1.1-0.9,2-2,2h-0.1c-1.1,0-2-0.9-2-2v-3.2C228.7,126.7,229.6,125.8,230.7,125.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.7,124.6h0.1c1,0,1.9,0.8,1.9,1.9v3.4c0,1-0.8,1.9-1.9,1.9h-0.1c-1,0-1.9-0.8-1.9-1.9v-3.4 C247.8,125.4,248.6,124.6,249.7,124.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M243.1,129.1c0,0,1.7,10.1,3.6,14.1c-0.9,1.8-6.1,3.3-6.1,3.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M188.5,137c0,0-4.8,1.1-2,6.8"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 197.4,
    y1: 233.1,
    x2: 266.6,
    y2: 222.3
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M180.1,283.4l6.4,28.9c0,0-16.3,32.4-21.3,48.5"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 107,
    y1: 170,
    x2: 106.4,
    y2: 164.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 103.8,
    y1: 160.9,
    x2: 98.3,
    y2: 161.6
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9997 -2.565278e-02 2.565278e-02 0.9997 -3.1225 2.4006)",
    className: "st6",
    cx: 92,
    cy: 122.9,
    rx: 4.2,
    ry: 4.7
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9997 -2.565278e-02 2.565278e-02 0.9997 -3.0651 3.0823)",
    className: "st6",
    cx: 118.6,
    cy: 121,
    rx: 3.1,
    ry: 3.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 108.2,
    y1: 160.3,
    x2: 113.8,
    y2: 159.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 105.7,
    y1: 157.5,
    x2: 105.1,
    y2: 151.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 64.1,
    y1: 361.5,
    x2: 351.8,
    y2: 361.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M224,103.6c0,0-2.9,12.6-9.9,16.3c-7,3.8-13.9,13-13.9,13"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M175.1,117.5c0,0-6.7,22-6.9,31.6s3.4,19.2,3.4,19.2"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 146.8,
    y1: 238.2,
    x2: 142.7,
    y2: 257.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 48.9,
    y1: 206.1,
    x2: 50.6,
    y2: 217.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 35.7,
    y1: 210.6,
    x2: 35.8,
    y2: 219.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 44.2,
    y1: 208.8,
    x2: 45.5,
    y2: 217.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 37.6,
    y1: 223.9,
    x2: 45.5,
    y2: 232
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 51.8,
    y1: 225.6,
    x2: 59.8,
    y2: 231.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 33.3,
    y1: 231.8,
    x2: 42,
    y2: 234.9
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M277,309.5c3.9,4.9,10,8.1,17.9,3c2.4-1.6,4.4-4,5.8-6.7v-0.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M379.1,214c0.7,0,3.4,0,4.1,0c0.2,0,0.4,0,0.4,0l-0.8,2.8c0,0-4.5,4.1-4.7,4.4 C377.9,221.6,378.9,214,379.1,214L379.1,214z M281.2,277.1c0.4-5.5,16.2-25,19.5-29.4c0.4-0.5,0.8-0.9,1.2-1.4 c4.1-4.1,25.3-25,30.1-28.9c4-4.4,8.6-8.2,13.4-11.4c2.6-1.8,5.4-3.5,8.2-4.8c1.6-0.7,2.8-0.2,4.4,0.4c1.6,0.6,3.3,1.3,4.9,1.9 c1.6,0.7,3.2,1.4,4.9,2c1.6,0.6,3.1,0.5,4.8,0.3c0.1,0,0.2,0,0.4-0.1c0.1,0,0.1,0,0.2,0c0.8-3.4,2.6-7,5.9-7.6l0,0 c0.3-0.1,0.5-0.1,0.8-0.1c0.6,0,1,0.6,0.9,1.3c-0.4,1.9-0.5,3.9-0.6,5.9c0.2,0,0.4,0,0.6,0l0,0c0.1,0,0.1,0,0.2,0 c0.8,0,1.6,0,2.4,0.1c0.4,0.1,0.8,0.1,1.2,0.1l0,0c0.2,0,0.3,0,0.5,0.1c0.3-1.6,0.6-3.3,0.9-4.9c0.1-0.8,0.3-1.6,0.6-2.3l0,0l0,0 c0.2-0.5,0.6-0.9,1.1-1.1c2.1-0.9,3.5-0.4,4-0.1l0.1,0.1c0.2,0.2,0.4,1.7,0.4,3.7c0,0,0,0,0,0.1l0,0c0,1.2,0,2.7,0,4.1v1.3 c0,0.8,0,1.5,0,2.2c0.7,0.7,1.3,1.5,1.5,2.3c0.3,1.2-0.6,2-1.5,2.6l0,0c0,0.7,0,1.3,0,2c0,1.3-0.1,2.5-0.8,3.6 c-0.1,0.2-0.3,0.4-0.4,0.6c0.2,0,0.4,0,0.5,0s0.1,0,0,0c0.6,0,1.2,0,1.8,0l0,0c0.2,0,0.4,0,0.5,0c1.4-1.9,2.7-3.9,4-5.9 c1.1-1.6,2.2-3.6,3.9-4.4c0.9-0.5,1.9-0.6,2.8-0.5l0,0c1.2,0.1,2.3,0.6,3.5,1.2c0.5,0.2,0.7,1.2,0.4,1.7c-0.2,0.4-0.4,0.8-0.6,1.1 c0.5,0.2,1,0.5,1.5,0.8c1.2,0.8,2.6,2.2,1.3,3.7c-0.6,0.7-1.3,1.2-2,1.8c-0.8,0.7-1.6,1.5-2.4,2.2c-2.9,2.7-5.9,5.4-8.8,8.1 c-1.3,1.2-2.5,2.6-4.3,2.9c-1.8,0.3-3.8,0.1-5.6,0c-3.9-0.2-7.8-0.4-11.7-0.7c-7.7-0.6-15.3-1.2-23-1.7c-3.2-0.2-6.4-0.4-9.6-0.5 l0,0c-6.9,13.2-14,26.3-21.3,39.2c-4,7.1-8,14.2-12,21.3c-2,3.5-3.9,7-5.9,10.5c-1,1.7-1.9,3.5-2.9,5.2v0.1"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 408.2,
    y1: 211.9,
    x2: 394.5,
    y2: 227.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M373,205.7l-2.5,10.2c0,0-2.4-2.1-8.4-1.9"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 296,
    y1: 243.7,
    x2: 297.5,
    y2: 251.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 380,
    y1: 205.2,
    x2: 379.1,
    y2: 214
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 392,
    y1: 208.2,
    x2: 392,
    y2: 214.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 384.8,
    y1: 205.5,
    x2: 383.7,
    y2: 214.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 390.7,
    y1: 219.7,
    x2: 383.7,
    y2: 227.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 378.1,
    y1: 221.3,
    x2: 371,
    y2: 226.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 394.5,
    y1: 227.2,
    x2: 386.8,
    y2: 230
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M239.1,155.7c0,0-6.5,0.8-8-1.5c-1.4-2.3,0-2.8-4.2-3.1"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDontknow);
export default __webpack_public_path__ + "static/media/dontknow.2a5c6eb769f6e64148187f5abe5cbd68.svg";
export { ForwardRef as ReactComponent };